export default __webpack_public_path__ + "static/media/voice.e88f4376.wav";